// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerSignInStyles } from "@sc/Overrides/Widgets/Common/HeaderSignIn";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerSignInStyles.headerClickable = {
    clickable: {
        css: css`
            &:hover,
            &.opened {
                ${TypographyStyle}, ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
                background: ${color("common.ui12")};
                border-radius: 4px;
            }
            padding: 5px 8px;
            ${xScreen("lte", "md")} {
                padding: 0;
            }
        `,
    },
};

headerSignInStyles.tippyStyles = {
    tooltipContent: {
        css: css`
            max-width: 432px;
            width: auto;
            transition-duration: 500ms !important;
            color: ${color("text.main")};
            background-color: ${color("common.white")};
            border: 1px solid ${color("common.border")};
            min-width: 200px;
            border-radius: 4px;
        `,
    },
};
